import { SPACE } from '@HoudiniUI/Theme/theme';
import { StyleSheet } from 'aphrodite';

export const hubSpotColor = '#FF5C35';

export const styleSheet = StyleSheet.create({
	ctaButton: {
		boxShadow: 'none',
		color: hubSpotColor,
		marginTop: SPACE[20],
		border: `1px solid ${hubSpotColor}`,
	},
	integrationTitle: {
		color: hubSpotColor,
	},
	graphic: {
		display: 'block',
		maxWidth: 200,
		marginBottom: SPACE[16],
	},
	integrationGraphic: {
		display: 'block',
		':nth-child(1n) > svg': {
			height: 'auto',
			width: 180,
		},
	},
});
